import React from 'react';
import { motion } from 'framer-motion';
import { Star, Award, BadgeCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const miniTestimonials = [{
  quote: 'Sus manos son oro puro.',
  author: 'Angela B.'
}, {
  quote: 'Tan delicada que me quedé dormida.',
  author: 'Mel'
}, {
  quote: 'Excelente servicio, se nota el profesionalismo y experiencia.',
  author: 'Dennisse C.'
}];
export function AboutKate() {
  const {
    t
  } = useLanguage();
  return <section id="kate" className="py-12 md:py-24 bg-brand-white relative overflow-hidden" data-id="element-23" data-mp="ei93s5m7liuu">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24" data-mp="tf8jkgr7si0e">
        <div className="text-center mb-10 md:mb-16" data-id="element-25" data-mp="ohq92lxjtuqa">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-26" data-mp="oi8bk0at156n">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-27" data-mp="20gu85i0q7biw">
              {t('about.title1')}
              <br data-id="element-28" data-mp="25f5jxyakzw3r" />
              <span className="block" data-id="element-29" data-mp="25engohpi4hmc">{t('about.title2')}</span>
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-30" data-mp="2a7yn4hqeiwdq"></div>
          </motion.div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-31" data-mp="2f5i2jkyu5f79">
          {/* Image Column */}
          <motion.div className="w-full lg:w-1/2 flex justify-center" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-32" data-mp="2k3jl84scnci7">
            <div className="relative group w-full max-w-md" data-id="element-33" data-mp="ytuk6m1u5xwj">
              {/* Decorative background elements */}
              <div className="absolute inset-0 bg-brand-gold/10 transform translate-x-4 translate-y-4 rounded-sm transition-transform duration-700 group-hover:translate-x-6 group-hover:translate-y-6" data-id="element-34" data-mp="224if7pcep6zs"></div>
              <div className="absolute inset-0 border border-brand-gold/30 transform -translate-x-4 -translate-y-4 rounded-sm transition-transform duration-700 group-hover:-translate-x-6 group-hover:-translate-y-6" data-id="element-35" data-mp="26492vk6mz703"></div>

              {/* Portrait */}
              <div className="relative z-10 overflow-hidden rounded-sm shadow-xl border border-brand-gold/20" data-id="element-36" data-mp="2g1nk3m0dvztg">
                <img src="https://cdn.magicpatterns.com/uploads/jWGUB2RBScED3p116XWAqo/KATE_2.png" alt="Kate - Fundadora de Tairu Aesthetics, en su estudio" className="w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" data-id="element-37" data-mp="2tt233suak10i" />

                {/* Soft bottom gradient for badge legibility */}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/45 to-transparent" data-id="element-38" data-mp="3if9m6a0jjxyf"></div>

                {/* Animated gold shine sweep */}
                <motion.div className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/30 to-transparent" initial={{
                x: '-50%',
                opacity: 0
              }} whileInView={{
                x: '450%',
                opacity: 1
              }} viewport={{
                once: true,
                amount: 0.3
              }} transition={{
                duration: 1.7,
                delay: 0.6,
                ease: 'easeInOut'
              }} data-id="element-39" data-mp="38g0s7h5oejc2" />

                {/* Google 5-star badge over the image */}
                <motion.div className="absolute bottom-4 left-4 right-4 z-20 bg-white/95 backdrop-blur-sm p-3 md:p-4 rounded-sm shadow-lg border border-brand-gold/20 flex items-center gap-3" initial={{
                opacity: 0,
                y: 16
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 0.45
              }} data-id="element-40" data-mp="2dni07rfa1t0v">
                  <div className="bg-brand-gold/10 p-2 rounded-full flex-shrink-0" data-id="element-41" data-mp="1kzcildjisk59">
                    <Award className="w-5 h-5 md:w-6 md:h-6 text-brand-gold" data-id="element-42" data-mp="1g1avmhiz40oi" />
                  </div>
                  <div data-id="element-43" data-mp="3fclj4fu38vbd">
                    <div className="flex text-brand-gold mb-1" data-id="element-44" data-mp="3fb0wrdhxgiol">
                      {[...Array(5)].map((_, i) => <motion.span key={i} initial={{
                      opacity: 0,
                      scale: 0.6
                    }} whileInView={{
                      opacity: 1,
                      scale: 1
                    }} viewport={{
                      once: true
                    }} transition={{
                      duration: 0.35,
                      delay: 0.7 + i * 0.09
                    }} data-id="element-45" data-mp="3iv17pokg7vbr" data-mpi={i}>
                          <Star className="w-3.5 h-3.5 fill-current" data-id="element-46" data-mp="38vjywy9wh1bk" />
                        </motion.span>)}
                    </div>
                    <p className="text-xs font-bold text-brand-charcoal leading-tight" data-id="element-47" data-mp="o7fgyhizhajw">
                      {t('about.badge')}
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Copy Column */}
          <motion.div className="w-full lg:w-1/2 space-y-6 text-lg text-brand-charcoal" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-48" data-mp="3uoed90trc7tx">
            <p className="font-serif text-2xl text-brand-gold-light italic" data-id="element-49" data-mp="3bz81jxrdsghm">
              {t('about.p1')}
            </p>

            <p data-id="element-50" data-mp="3qo43dd2ugx9s">{t('about.p2')}</p>

            <div className="flex items-start gap-3 bg-brand-cream p-4 rounded-sm border-l-4 border-brand-gold my-6" data-id="element-51" data-mp="3lvb06tn0xwzt">
              <BadgeCheck className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-52" data-mp="2y4p5e421697r" />
              <p className="text-sm" data-id="element-53" data-mp="2t7oy5ptg30f2">
                {t('about.p3_1')}
                <strong className="text-brand-brown" data-id="element-54" data-mp="18p4p09mwn37o">
                  {t('about.p3_bold')}
                </strong>
                {t('about.p3_2')}
              </p>
            </div>

            <p data-id="element-55" data-mp="1dhe8b6til50z">{t('about.p4')}</p>

            <p className="font-medium text-brand-brown mt-8" data-id="element-56" data-mp="yrgikmfxs79o">{t('about.p5')}</p>

            {/* Mini Testimonials */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8" data-id="element-57" data-mp="13qjpydje2pkt">
              {miniTestimonials.map((test, idx) => <div key={idx} className="bg-white p-4 border border-brand-gold/10 rounded-sm shadow-sm text-center" data-id="element-58" data-mp="1rd9mizcyxry1" data-mpi={idx}>
                  <div className="flex justify-center text-brand-gold mb-2" data-id="element-59" data-mp="1idwfedcbhfgh">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-60" data-mp="1mi43q9ev4te6" data-mpi={i} />)}
                  </div>
                  <p className="text-sm italic mb-2" data-id="element-61" data-mp="b14ddjc2soms">"{test.quote}"</p>
                  <p className="text-xs font-bold text-brand-brown" data-id="element-62" data-mp="b2fdn96bbe95">
                    — {test.author}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}